// ** React Imports
import { Fragment, useEffect, useRef, useState } from 'react'
// ** Table Data & Columns
import { columns } from './components/data'
import '@styles/react/libs/tables/react-dataTable-component.scss'
// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import { ChevronDown } from 'react-feather'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

// ** Reactstrap Imports
import { Card, CardTitle, CardHeader, Spinner } from 'reactstrap'
import './style.scss'
import axios from 'axios'
import moment from 'moment'
import { documentStatusGlobal } from '../../../utility/helpers'
import { useParams } from 'react-router-dom'
import InvoicesFilter from './components/invoices-filter'
import { useDispatch, useSelector } from 'react-redux'
import { getTransactions } from './store'

const getCurrentDate = () => {
  const today = new Date()
  return today.toISOString().split('T')[0] // Formato YYYY-MM-DD
}

const MySwal = withReactContent(Swal)

const Invoices = ({ transactions = [] }) => {
  // ** States
  const { data, isPending } = useSelector((state) => state.transactions)
  const dispatch = useDispatch()
  const params = useParams()
  const [currentPage, setCurrentPage] = useState(0)
  const [searchValue, setSearchValue] = useState('')
  // const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState(data)
  const [totalRecords, setTotalRecords] = useState(data.length || 0)
  const [filters, setFilters] = useState({
    startDate: getCurrentDate(),
    endDate: getCurrentDate(),
  })
  const pageSize = 20
  const abortControllerRef = useRef(null)

  useEffect(() => {
    setTotalRecords(data.length)
  }, [data])

  useEffect(() => {
    setCurrentPage(0)
  }, [filters])

  useEffect(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current?.abort() // Cancelar petición anterior si existe
    }
    abortControllerRef.current = new AbortController()
    dispatch(
      getTransactions({
        filters,
        page: currentPage,
        size: pageSize,
        signal: abortControllerRef.current.signal,
      })
    )
  }, [dispatch, currentPage])

  const [documentStatusDefinition] = useState(documentStatusGlobal)

  const [modal, setModal] = useState(false)
  const [loadModal, setLoadModal] = useState(false)

  const [documentModal, setDocumentModal] = useState('')

  const [filterData, setFilterData] = useState({
    pageNumber: 1,
    pageSize: 25,
    status: +params.statusDocument,
  })

  const onFilter = (filterProp) => {
    setFilterData({ ...filterData, ...filterProp })
  }

  /*
    useEffect(() => {
        getDocuments();
    }, [filterData]);*/

  const getDocuments = async () => {
    const documentsUrl = `${process.env.REACT_APP_API_URL}/documents/getAll`
    const response = await axios.post(documentsUrl, {
      ...filterData,
      pageNumber: +currentPage + 1,
    })

    const documentsList = transactions.map((item) => {
      return {
        noDocument: item.id,
        clientName: item.clientName,
        createDate: moment(item.createdAt).format('DD/MM/YYYY hh:mm a'),
        documentUrl: item.url,
        documentName: item.title,
        clientEmail: item.clientEmail,
        clientPhone: item.clientPhone,
        area: item.area,
        clientIdentification: item.clientIdentification,
      }
    })
    // setData(documentsList);
    // setTotalRecords(response.data.totalRecords);
  }
  /*
    useEffect(() => {
        getDocuments();
    }, []);*/

  const toggleModal = (show, document) => {
    setModal(show)
    if (show && document) {
      getDocumentTracking(document)
    }
  }

  // ** Function to handle filter
  const handleFilter = (e) => {
    const value = e.target.value
    let updatedData = []
    setSearchValue(value)

    if (value.length) {
      updatedData = data.filter((item) => {
        const startsWith =
          item.noDocument
            .toString()
            .toLowerCase()
            .startsWith(value.toLowerCase()) ||
          item.clientName.toLowerCase().startsWith(value.toLowerCase()) ||
          item.createDate.toLowerCase().startsWith(value.toLowerCase()) ||
          item.documentUrl.toLowerCase().startsWith(value.toLowerCase())

        const includes =
          item.noDocument
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          item.clientName.toLowerCase().includes(value.toLowerCase()) ||
          item.createDate.toLowerCase().includes(value.toLowerCase()) ||
          item.documentUrl.toLowerCase().includes(value.toLowerCase())

        if (startsWith) {
          return startsWith
        } else if (!startsWith && includes) {
          return includes
        } else return null
      })
      setFilteredData(updatedData)
      setSearchValue(value)
    }
  }

  const handleClearFilters = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current?.abort() // Cancelar petición activa
    }
  }

  // ** Function to handle Pagination
  const handlePagination = (page) => {
    setCurrentPage(page.selected)
  }

  // ** Pagination Previous Component
  const Previous = () => {
    return (
      <Fragment>
        <span className="align-middle d-none d-md-inline-block">
          Anterior
        </span>
      </Fragment>
    )
  }

  // ** Pagination Next Component
  const Next = () => {
    return (
      <Fragment>
        <span className="align-middle d-none d-md-inline-block">
          Siguiente
        </span>
      </Fragment>
    )
  }

  const CustomPagination = () => {
    if (isPending) {
      return (
        <div className="d-flex justify-content-end pe-1 m-1">
          <Spinner
            color="primary"
            className="me-6"
          />
        </div>
      )
    }

    return (
      <ReactPaginate
        previousLabel={<Previous />}
        nextLabel={<Next />}
        forcePage={currentPage}
        onPageChange={(page) => handlePagination(page)}
        pageCount={data.totalPages}
        breakLabel={'...'}
        pageRangeDisplayed={2}
        marginPagesDisplayed={5}
        activeClassName={'active'}
        pageClassName={'page-item'}
        nextLinkClassName={'page-link'}
        nextClassName={'page-item next'}
        previousClassName={'page-item prev'}
        previousLinkClassName={'page-link'}
        pageLinkClassName={'page-link'}
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName={
          'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'
        }
      />
    )
  }

  return (
    <Fragment>
      {/* {isPending && <FullPageSpinner message="Cargando datos..." />}  */}
      <InvoicesFilter
        onFilter={onFilter}
        setFilters={setFilters}
        abortControllerRef={abortControllerRef}
        handleAbortFilters={handleClearFilters}
      />
      <Card>
        {data?.data?.length > 0 && (
          <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
            <CardTitle tag="h4">Documentos con error</CardTitle>
          </CardHeader>
        )}

        <div className={`react-dataTable master-view-batch-table`}>
          {data?.data?.length > 0 && (
            <DataTable
              noHeader
              pagination
              columns={columns(toggleModal)}
              paginationPerPage={20}
              className="react-dataTable"
              responsive={true}
              sortIcon={<ChevronDown size={10} />}
              paginationComponent={CustomPagination}
              paginationDefaultPage={currentPage + 1}
              data={data?.data || []}
            />
          )}
        </div>
      </Card>
    </Fragment>
  )
}

export default Invoices
